export const unassignConfirmText = 'Are you sure you want to unassign all milestones from the file?';
export const overwriteConfirmText = 'Are you sure you want to overwrite milestones for the selected files?';
